import { FETCH_WHITE_LABEL_INVOICE_DATA } from '../actions/types';
type InitialStates = {
  print: boolean;
  activeWallet: boolean;
  activePrizeWallet: boolean;
  paymentType: string;
  pgwType: number;
  paymentMethod: null;
  gatewaysList: {
    data: any;
    loading: boolean;
  } | null;
  expired: boolean;
  eligible: {
    eligible: boolean;
    description: string;
  } | null;
};
const INITIAL_STATES = {
  print: false,
  activeWallet: false,
  activePrizeWallet: false,
  paymentType: 'payByBank',
  pgwType: 1,
  paymentMethod: null,
  installmentPaymentMethod: null,
  gatewaysList: null,
  expired: false,
  paymentWay: {
    value: 'پرداخت مستقیم آنلاین',
    id: 1
  },
  eligible: null
};
interface WhiteLabelInvoiceReducerType extends InitialStates {
  data: {
    data: Data | null;
  } | null;
  loading: boolean;
}
interface Data {
  invoice: any;
  credit: number;
  payment_motivation: null;
}
export const whiteLabelInvoiceReducer = (state: WhiteLabelInvoiceReducerType = {
  data: null,
  loading: false,
  ...INITIAL_STATES
}, {
  type,
  data,
  loading
}) => {
  switch (type) {
    case FETCH_WHITE_LABEL_INVOICE_DATA:
      return {
        ...state,
        data,
        loading
      };
    default:
      return state;
  }
};